import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  palette: {
    primary: { main: '#86B29C' },
    secondary: { main: '#b28c86' },
  },
});
